'use client';

import dynamic from 'next/dynamic';

import { useState, useEffect } from 'react';
import type { Locale } from '@/lib/i18n';

const AboutSection = dynamic(() => import('@/components/AboutSection'), { ssr: false });

interface AboutSectionClientProps {
  locale: Locale;
}

export default function AboutSectionClient({ locale }: AboutSectionClientProps) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) return null;
  return <AboutSection locale={locale} />;
}
